export enum LedgerType {
    Debet = 0,
    Credit = 1,
    Costs = 2,
    Proceeds = 3
}

export const LedgerTypeLabels: Record<LedgerType, string> = {
    [LedgerType.Debet]: "Debet",
    [LedgerType.Credit]: "Credit",
    [LedgerType.Costs]: "Costs",
    [LedgerType.Proceeds]: "Proceeds"
};